export default "__VITE_ASSET__DLq3yJkO__"